import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { examNameService } from '../services/examNameService'

export const getAllExamnames = createAsyncThunk(
  'examname/getAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await examNameService.getAll()
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const getOneExamname = createAsyncThunk(
  'examname/getOne',
  async (data, { rejectWithValue }) => {
    try {
      const response = await examNameService.getOne(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const createExamname = createAsyncThunk(
  'examname/create',
  async (data, { rejectWithValue }) => {
    try {
      const response = await examNameService.createExamname(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const editExamname = createAsyncThunk(
  'examname/edit',
  async (data, { rejectWithValue }) => {
    try {
      const response = await examNameService.editExamname(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

export const deleteExamname = createAsyncThunk(
  'examname/delete',
  async (data, { rejectWithValue }) => {
    try {
      const response = await examNameService.deleteOne(data)
      return response.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  },
)

const initialState = {
  data: [],
  singleData: {},
  loading: false,
  error: false,
  message: '',
}

const slice = createSlice({
  name: 'examname',
  initialState,
  reducers: {
    checkAll: (state) => {
      state.isChecked = !state.isChecked
    },
    resetSingleData: (state) => {
      state.singleData = {}
    },
  },
  extraReducers: {
    [getAllExamnames.pending]: (state) => {
      if (state.data.length <= 0) {
        state.loading = true
      }
    },
    [getAllExamnames.fulfilled]: (state, action) => {
      state.error = false
      state.data = action.payload
      state.loading = false
    },
    [getAllExamnames.rejected]: (state, action) => {
      state.error = true
      state.message = action.payload
      state.loading = false
    },

    [getOneExamname.pending]: (state) => {
      state.loading = true
    },
    [getOneExamname.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
      state.singleData = payload
    },
    [getOneExamname.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [createExamname.pending]: (state) => {
      state.loading = true
    },
    [createExamname.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [createExamname.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [editExamname.pending]: (state) => {
      state.loading = true
    },
    [editExamname.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [editExamname.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },

    [deleteExamname.pending]: (state) => {
      state.loading = true
    },
    [deleteExamname.fulfilled]: (state, { payload }) => {
      state.message = payload?.message
      state.loading = false
    },
    [deleteExamname.rejected]: (state, { payload }) => {
      state.error = true
      state.message = payload
      state.loading = false
    },
  },
})

export const { resetSingleData } = slice.actions
export default slice.reducer
